import { _ as __rest, a as __assign } from '../../tslib.es6-2259bcab.js';
import { c as classNames } from '../../index-444bb648.js';
import * as React from 'react';
import { s as skeletonStyles } from '../../skeleton.module-454f2b7a.js';

var styles = {"link":"TextLink_link_e48c9658","underline":"TextLink_underline_e48c9658","action":"TextLink_action_e48c9658","focus-visible":"TextLink_focus-visible_e48c9658","interface":"TextLink_interface_e48c9658","disabled":"TextLink_disabled_e48c9658","linkText":"TextLink_linkText_e48c9658","skeleton":"TextLink_skeleton_e48c9658"};

var TextLink = React.forwardRef(function TextLink(_a, ref) {
    var _b;
    var children = _a.children, _c = _a.hasUnderline, hasUnderline = _c === void 0 ? true : _c, _d = _a.variant, variant = _d === void 0 ? "action" : _d, className = _a.className, isSkeleton = _a.isSkeleton, isDisabled = _a.isDisabled, href = _a.href, otherProps = __rest(_a, ["children", "hasUnderline", "variant", "className", "isSkeleton", "isDisabled", "href"]);
    // Preventing navigation when link isDisabled but user can navigate using keyboard
    var preventAction = function (event) {
        event.preventDefault();
    };
    return (React.createElement("a", __assign({ onClick: isDisabled ? function (e) { return preventAction(e); } : undefined, "aria-busy": isSkeleton, className: classNames(styles.link, styles[variant], (_b = {},
            _b[skeletonStyles.skeleton] = isSkeleton,
            _b[styles.skeleton] = isSkeleton,
            _b[styles.disabled] = isDisabled,
            _b[styles.underline] = hasUnderline,
            _b), className), ref: ref, href: href }, otherProps),
        React.createElement("span", { className: styles.linkText }, children)));
});
var textLinkStyles = styles.link;

export { TextLink, textLinkStyles };
